import { createTheme } from '@mui/material/styles';

export default createTheme({
    palette: {
        common: {
            black: '#202524',
            white: '#fff'
        },
        primary: {
            main: '#02836F',
            50: '#E8F2EE',
            100: '#CCE3DA',
            200: '#02836F',
            300: '#5D9B8B', // Opacity 80%
            400: '#88E1D5',
            500: '#27C6B0',
            700: '#045F51',
            800: '#003D33'
        },
        secondary: {
            main: '#FFF',
            50: '#FFF',
            100: '#F8F4F0',
            200: '#F9EDE9',
            300: '#F6D4C6',
            400: '#EDE9DF',
            500: '#D2C8B7'
        },
        grey: {
            200: 'rgba(217, 217, 217, 0.3)', // Opacity 30%
            500: '#9FA4A1',
            700: '#565F5D',
        },
        error: {
            main: '#FF0707',
            50: '#ff07071a' // Opacity 10%
        },
        background: {
            default: '#F5F9F7',
            paper: '#F8F4F0'
        },
        text: {
            primary: '#202524',
            secondary: '#FFF'
        }
    },

    breakpoints: {
        values: {
            xs: 480,
            sm: 576,
            md: 769,
            lg: 992,
            xl: 1200,
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '1000px',
                    padding: '8px 20px',
                    fontWeight: 500,
                    boxShadow: 'none',
                    textTransform: 'unset',
                    border: '2px solid #02836F',
                    ':hover': {
                        boxShadow: 'none'
                    }
                },
                contained: {
                    background: '#02836F',
                    color: 'white',
                    ':hover': {
                        background: '#029780'
                    },
                    ':disabled': {
                        border: '2px solid #e0e0e0'
                    }
                },
                outlined: {
                    borderWidth: '2px !important',
                    borderColor: '#02836F',
                    color: '#02836F',
                    fontWeight: 500,
                    ':hover': {
                        background: '#02836F',
                        color: 'white'
                    }
                },
                text: {
                    background: 'transparent',
                    textDecoration: 'underline',
                    transition: '0.2s ease',
                    border: 'none',
                    ':hover': {
                        background: 'unset',
                        textDecoration: 'underline',
                        color: '#003D33'
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    color: '#FFF',
                    backgroundColor: '#5D9B8B',
                    padding: '18px',
                    borderRadius: '88px',
                    display: 'flex',
                    gap: '10px',
                    fontSize: '16px'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    width: '100%',
                    borderRadius: '5px',
                    backgroundColor: 'white',
                    input: {
                        ':hover': {
                            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.2)'
                        },
                        '::placeholder': {
                            fontStyle: 'italic'
                        }
                    },
                    fieldset: {
                        outline: 'none'
                    }
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    '&.MuiCheckbox-root': { padding: 0 },
                    '& input': {
                        opacity: 1,
                        border: 'none'
                    },
                    '&.Mui-checked': {
                        '& input': {
                            opacity: 0
                        }
                    }
                }
            }
        }
    }
});
